module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#automobile",
      toString: function () {
        return this.url;
      }
    }